import type { IntlService } from 'ember-intl';
import type { IResourceName } from 'volta/models/base-model';
import type BvMetricsService from 'volta/services/bv-metrics';
import type SkuModalService from 'volta/services/sku-modal-service';
import type { TError } from 'volta/utils/error-utils';
import { defaultErrorHandler } from 'volta/utils/error-utils';

import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

import type Transition from '@ember/routing/transition';
import type { BaseRoute } from 'volta/routes/base';
import type RouterService from "@ember/routing/router-service";

export default class ProtectedController extends Controller {
  @service intl!: IntlService;
  @service bvMetrics!: BvMetricsService;
  @service skuModalService!: SkuModalService;
  @service router!: RouterService;

  route!: BaseRoute;
  resourceName!: IResourceName;

  // Query params will be set from the BaseModel model hook
  get queryParamsValues() {
    return this.route.queryParamsValues;
  }

  _onDefaultError(error: TError) {
    defaultErrorHandler(error as TError);
  }

  trackEvent(actionName: string, label?: string, value?: any) {
    this.bvMetrics.trackAction(this, actionName, label, value);
  }

  @action
  refreshRoute(): Transition | Promise<unknown> {
    return this.route.refresh();
  }

  @action
  refreshModel(params?: any) {
    this.router.transitionTo({ queryParams: params ?? this.queryParamsValues });
  }
}
